import { Point, Circle as CircleGeom } from 'ol/geom';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import Feature from 'ol/Feature';
// import { Style, Fill, Stroke, Icon } from 'ol/style';
import { Style, Fill, Stroke, Icon, Circle as CircleStyle } from 'ol/style';

import triangleIcon from '../../assets/svgs/trianglearrow.svg';

// Globals
let userLocationLayer = null;
let userLocationFeature = null;
let accuracyFeature = null;
let userWatchId = null;

let lastHeading = 0; // persist across location updates


export const locateUser = (map) => {
  if (!navigator.geolocation || !map) {
    alert("Geolocation not supported.");
    return;
  }

  // Init user layer
  if (!userLocationLayer) {
    const source = new VectorSource();
    userLocationFeature = new Feature();
    accuracyFeature = new Feature(); // accuracy circle

    userLocationFeature.setStyle(
      new Style({
        image: new CircleStyle({
          radius: 8,
          fill: new Fill({ color: "#007bff" }),
          stroke: new Stroke({ color: "#ffffff", width: 2 }),
        }),
      })
    );


    accuracyFeature.setStyle(
      new Style({
        fill: new Fill({ color: "rgba(0, 123, 255, 0.1)" }),
        stroke: new Stroke({ color: "#007bff", width: 1 }),
      })
    );

    source.addFeatures([accuracyFeature, userLocationFeature]);

    userLocationLayer = new VectorLayer({
      source,
      title: "User Location",
    });

    map.addLayer(userLocationLayer);
  }

  // Get and center once on current location
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const coords = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
      const heading = pos.coords.heading || 0;
      const accuracy = pos.coords.accuracy || 50;

      updateLocation(coords, heading, accuracy);
      map.getView().animate({ center: coords, zoom: 16 });
    },
    (err) => {
      console.error("Geolocation error:", err);
      alert("Could not fetch your location.");
    },
    { enableHighAccuracy: true }
  );

  // Start watching movement
  if (!userWatchId) {
    userWatchId = navigator.geolocation.watchPosition(
      (pos) => {
        const coords = fromLonLat([pos.coords.longitude, pos.coords.latitude]);
        const heading = pos.coords.heading || 0;
        const accuracy = pos.coords.accuracy || 50;

        updateLocation(coords, heading, accuracy);
      },
      (err) => {
        console.error("Error watching position:", err);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 3000,
        timeout: 5000,
      }
    );
  }
};

const updateLocation = (coords, heading, accuracy) => {
  if (!userLocationFeature || !accuracyFeature) return;

  // Update location and accuracy
  userLocationFeature.setGeometry(new Point(coords));
  accuracyFeature.setGeometry(new CircleGeom(coords, accuracy));

  const style = userLocationFeature.getStyle();
  const image = style && style.getImage();

  if (image) {
    // Check if heading is a valid number and not zero (zero is often unreliable)
    if (typeof heading === "number" && heading > 0 && heading < 360 && !isNaN(heading)) {
      lastHeading = heading; // Update stored heading
      image.setRotation(heading);
    } else {
      // Use last valid heading
      image.setRotation(lastHeading);
    }
  }
};


